import { projetosRecentes } from "@/mocks/dashboard";

export default function RecentProjects() {
  const statusColors: Record<string, string> = {
    ativo: "bg-primary-100 text-primary-700",
    concluido: "bg-secondary-100 text-secondary-700",
    pausado: "bg-warning-100 text-warning-700",
  };

  const statusLabels: Record<string, string> = {
    ativo: "Ativo",
    concluido: "Concluído",
    pausado: "Pausado",
  };

  return (
    <div className="bg-white rounded-xl border border-background-200/70">
      <div className="flex items-center justify-between px-5 pt-5 pb-3">
        <h3 className="text-sm font-semibold text-foreground-900">Projetos Recentes</h3>
        <a
          href="/projetos"
          className="text-xs text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
        >
          Ver todos
          <i className="ri-arrow-right-line ml-1"></i>
        </a>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-t border-background-200/70">
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500">Projeto</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500">Município</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500">Árvores</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500">Progresso</th>
              <th className="text-left px-5 py-2.5 text-xs font-medium text-foreground-500">Status</th>
            </tr>
          </thead>
          <tbody>
            {projetosRecentes.slice(0, 5).map((proj) => (
              <tr
                key={proj.id}
                className="border-t border-background-200/70 hover:bg-background-50 transition-colors cursor-pointer"
              >
                <td className="px-5 py-3">
                  <p className="text-sm font-medium text-foreground-900">{proj.nome}</p>
                  <p className="text-xs text-foreground-500">{proj.id}</p>
                </td>
                <td className="px-5 py-3">
                  <span className="text-sm text-foreground-700">{proj.municipio}</span>
                </td>
                <td className="px-5 py-3">
                  <span className="text-sm font-medium text-foreground-900">
                    {proj.totalArvores.toLocaleString("pt-BR")}
                  </span>
                </td>
                <td className="px-5 py-3">
                  <div className="flex items-center gap-2 min-w-[100px]">
                    <div className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-primary-500 transition-all"
                        style={{ width: `${proj.progresso}%` }}
                      ></div>
                    </div>
                    <span className="text-xs font-medium text-foreground-600 w-8 text-right">
                      {proj.progresso}%
                    </span>
                  </div>
                </td>
                <td className="px-5 py-3">
                  <span className={`badge ${statusColors[proj.status]}`}>
                    {statusLabels[proj.status]}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}